import { SpecialArticlePage } from '../components/SpecialArticlePage';
import { WoofyHoverImage } from '../components/WoofyHoverImage';

const SAGA_SLUG = 'saga';
const TEAM_IMAGE_SRC = '/images/team_arvid_2.jpeg';

export function SagaPage() {
  return (
    <SpecialArticlePage
      slug={SAGA_SLUG}
      hideArticleMeta
      stripMarkdownImages
      hero={
        <WoofyHoverImage
          src={TEAM_IMAGE_SRC}
          alt="The Arvid team"
          className="aspect-video w-full rounded-card"
        />
      }
    />
  );
}
